package com.milta.core.localization.translations.sq

import com.milta.core.localization.WebImportRouteStrings

internal val WebImportRoute = WebImportRouteStrings(
    headerSubtitle = "Ngarkoni një skedar dërgesash dhe caktojani një shoferi",
    stepImport = "Importo",
    stepVerifyAssign = "Verifiko dhe cakto",
    stepValidateSend = "Konfirmo dhe dërgo itineraret",
    dropzoneTitle = "Tërhiqni dhe lëshoni skedarin tuaj të dërgesave",
    dropzoneOrPrefix = "ose",
    browseFilesLink = "shfletoni skedarët tuaj",
    browseFilesButton = "Shfleto skedarët",
    constraintsLabel = "Excel (.xlsx, .xls) ose CSV · maks. 500 ndalesa · 10 MB",
    expectedColumnsEyebrow = "Kolonat e pritura në skedar",
    columnRecipientName = "Emri i marrësit",
    columnAddress = "Adresa e plotë",
    columnDeadline = "Ora limit",
    columnPhone = "Telefoni",
    requiredPillLabel = "Kërkohet",
    optionalPillLabel = "Opsionale",
    analysingLabel = "Duke analizuar…",
    invalidFileTitle = "Skedar i palexueshëm ose format i papërkrahur",
    invalidFileMessage = "\"%s\" nuk mundi të analizohej. Përdorni një skedar Excel (.xlsx, .xls) ose CSV që respekton kolonat e pritura.",
    chooseAnotherFileButton = "Zgjidh një skedar tjetër",
    extractionFailedTitle = "Nuk mund të nxirren dërgesat",
    extractionFailedMessage = "Skedari \"%s\" u lexua, por nuk u gjet asnjë rresht i përdorshëm. Kontrolloni nëse përmban kolonat e pritura.",
    serviceUnavailableTitle = "Shërbimi i analizës përkohësisht i padisponueshëm",
    serviceUnavailableMessage = "Nuk mund ta analizojmë skedarin tuaj për momentin. Provoni përsëri pas pak.",
    retryButton = "Provo përsëri",
    fileImportedStatus = "Skedari u importua",
    stopsDetectedSuffix = "ndalesa të zbuluara",
    replaceFileLink = "↺ Zëvendëso",
    assignToEyebrow = "Cakto tek",
    selectDriverRequiredError = "Ju lutemi zgjidhni të paktën një shofer para se të dërgoni itinerarin.",
    selectedDriversCountSuffix = "shoferë të zgjedhur",
    optimizeRouteButton = "Optimizo itinerarin",
    tableCaptionLead = "Kontrolloni dhe korrigjoni ndalesat para se të dërgoni",
    tableCaptionHint = "Klikoni ikonën e lapsit për të korrigjuar një rresht",
    columnHeaderIndex = "#",
    columnHeaderRecipientName = "Emri i marrësit",
    columnHeaderAddress = "Adresa",
    columnHeaderPhone = "Telefoni",
    columnHeaderDeadline = "Ora limit",
    dashPlaceholder = "—",
    freeFormatBanner = "U zbulua format i lirë — kolonat nuk mund të njiheshin automatikisht, kontrolloni çdo rresht para se të dërgoni.",
    incompleteStopsBannerSuffix = "ndalesa jo të plota — mungon emri ose adresa, për t'u korrigjuar para dërgimit.",
    rowFlagMissingName = "⚠ emër mungon",
    rowFlagMissingAddress = "⚠ adresë mungon",
    alreadyDispatchedBanner = "Ky itinerar i është dërguar tashmë një shoferi — rifreskoni faqen për të filluar një import të ri.",
    routeNotFoundError = "Itinerari nuk u gjet. Rifreskoni faqen dhe provoni përsëri.",
    validationErrorGeneric = "Ju lutemi kontrolloni informacionin e futur.",
    submitServerError = "Ndodhi një gabim. Provoni përsëri.",
    submitOptimizationUnavailableError = "Shërbimi i optimizimit përkohësisht i padisponueshëm. Itinerari nuk u krijua — provoni përsëri pas pak.",
    sendWithoutOptimizationButton = "Dërgo pa optimizim",
    dispatchSuccessMessage = "Itinerari u dërgua me sukses tek %s",
    dispatchSuccessBatchMessage = "Itineraret u dërguan me sukses tek %d shoferë",
    tooManyStopsError = "Ky skedar përmban më shumë se 500 dërgesa. Ju lutemi ndajeni para se ta importoni.",
    resultHeaderMiddle = "dërgesa të ndara mes",
    resultDriverSingularSuffix = "shofer",
    resultDriverPluralSuffix = "shoferë",
    resultDistanceLabel = "Distanca",
    resultDurationLabel = "Kohëzgjatja e vlerësuar",
    resultMetricNotCalculatedLabel = "E pallogaritur",
    resultStopsChipSuffix = "ndalesa",
    resultMoreStopsTemplate = "+ %d ndalesa të tjera",
    resultStopsLoadError = "Ndalesat e këtij itinerari nuk u ngarkuan dot.",
    resultDispatchButton = "Konfirmo dhe dërgo itineraret",
)
